import AppRoutes from './MainRoutes';
import * as containerTypes from './containerTypes';
import * as constants from './constants';

export default {
  AppRoutes,
  containerTypes,
  constants,
};
